// * GET =====================================
export const EXPORT_TEMPLATE_GET_LIST_TEMPLATES = `/export_template/list_templates`;
export const EXPORT_TEMPLATE_GET_GET_TEMPLATE = `/export_template/get_template`;
export const EXPORT_TEMPLATE_GET_GET_EXPORT_TEMPLATE_HTML_OPTIONS = `/export_template/get_export_template_html_options`;

// * PATCH ===================================

// * POST ====================================
export const EXPORT_TEMPLATE_POST_ADD_TEMPLATE = `/export_template/add_template`;
export const EXPORT_TEMPLATE_POST_EDIT_TEMPLATE = `/export_template/edit_template`;
export const EXPORT_TEMPLATE_POST_LIST_TEMPLATES = `/export_template/list_templates`;
export const EXPORT_TEMPLATE_POST_TOGGLE_TEMPLATE_STATUS = `/export_template/toggle_template_status`;

// * DELETE ==================================

// * PUT =====================================
